import widget from './widget';

export default {
  ...widget,
  styles: {
    skeletonColor: 'dark',
    iconsColor: 'c-light',
  },
};
